<app-programtitle title="Electricity bill calculator"></app-programtitle>

<p> Write a program which will receive previous and current meter readings from the user and calculates the final amount to pay. Use price per unit as 10.5.</p>

<app-editor code="{{program}}"> </app-editor>

